import React, {Component} from 'react'
import Settings from '../../Settings'
import {Page} from './../common/StyledComponents'
import ReactGA from 'react-ga'
import {Container, Button} from './Components'

import nextButtonNl from './../../theme/img/next-video-nl.png'
import nextButtonFr from './../../theme/img/next-video-fr.png'
import mainMenuNl from './../../theme/img/main-menu-nl.png'
import mainMenuFr from './../../theme/img/main-menu-fr.png'

const buttons = {
  next: {
    nl: nextButtonNl,
    fr: nextButtonFr,
  },
  mainMenu: {
    nl: mainMenuNl,
    fr: mainMenuFr,
  },
}

export class VideoEnd extends Component {
  handleContactClick = (currentVideo, category, locale) => e => {
    window.open(category.contactUrl[locale])

    ReactGA.event({
      category: 'Contact',
      action: 'Click',
      label: `${currentVideo.label[locale]} from category ${category.label[locale]}`,
    })
  }

  render() {
    const {
      match: {
        params: {locale, categoryKey, videoKey},
      },
    } = this.props

    const category = Settings.categories.find(category => category.key === categoryKey)
    const videosInCategory = category.videos
    const currentVideoIndex = videosInCategory.findIndex(video => video.key === videoKey)
    const currentVideo = videosInCategory[currentVideoIndex]
    const nextVideo = videosInCategory[currentVideoIndex < videosInCategory.length - 1 ? currentVideoIndex + 1 : 0]

    ReactGA.event({
      category: 'Video',
      action: 'End',
      label: `${currentVideo.label[locale]} from category ${category.label[locale]}`,
    })

    return (
      <Page>
        <Container>
          <Button to={`/${locale}/category/${categoryKey}/video/${nextVideo.key}`}>
            <img src={buttons.next[locale]} alt="" />
          </Button>
          <Button to={`/${locale}/category/${categoryKey}`}>
            <img src={buttons.mainMenu[locale]} alt="" />
          </Button>
        </Container>
      </Page>
    )
  }
}
